import React from 'react';
import { string, number, shape } from 'prop-types';
import { Slice } from 'victory';

// custom data component for <VictoryPie />
const CustomDataComponent = props => {
  const { datum, style, pieSectionName } = props;
  let NewProps = props;
  // pieSectionName from state above
  if (datum && datum.xName === pieSectionName) {
    NewProps = {
      ...props,
      style: {
        ...style,
        stroke: style.fill,
        strokeWidth: '10',
        strokeLinejoin: 'round',
      },
      cornerRadius: 4,
      sliceStartAngle: datum.startAngle + 2,
      sliceEndAngle: datum.endAngle - 2,
    };
  }

  return <Slice {...NewProps} />;
};

CustomDataComponent.propTypes = {
  pieSectionName: string,
  datum: shape({
    xName: string,
    startAngle: number,
    endAngle: number,
  }),
  style: shape({
    fill: string,
  }),
};

export default CustomDataComponent;



// WEBPACK FOOTER //
// ./src/common/components/DoughnutChart/CustomDataComponent/index.js